import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DialogTitle, DialogActions, DialogContent, Typography, Button, Box, Avatar, List, ListItem, ListItemText, ListItemAvatar, Dialog } from "@mui/material";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { useGetUsersRolesQuery } from "../services/accounts";
import { MD5 } from "../../utility/md5";
type NoPermissionProps = {
  onClose: () => void;
  headerTitle?: string;
  headerSubtitle?: string;
};
export const NoPermission = ({
  onClose,
  headerSubtitle,
  headerTitle
}: NoPermissionProps) => {
  const {
    t
  } = useTranslation();
  const {
    data: users
  } = useGetUsersRolesQuery();
  const ownersAndAdmins = useMemo(() => {
    if (users?.length) {
      const owners = users.filter(user => user.role?.name?.toLowerCase() === "owner").sort((a, b) => a.firstName.localeCompare(b.firstName));
      const admins = users.filter(user => user.role?.name?.toLowerCase() === "admin").sort((a, b) => a.firstName.localeCompare(b.firstName));
      return [...owners, ...admins];
    }
  }, [users]);
  return <Dialog open onClose={onClose} maxWidth="xs" data-sentry-element="Dialog" data-sentry-component="NoPermission" data-sentry-source-file="NoPermission.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="NoPermission.tsx">
        <ErrorRoundedIcon color="error" sx={{
        padding: 1,
        borderRadius: "20px",
        backgroundColor: "red.100",
        display: "block",
        width: "40px",
        height: "40px",
        mb: 1.5
      }} data-sentry-element="ErrorRoundedIcon" data-sentry-source-file="NoPermission.tsx" />
        <Box fontWeight={700} mb={1} data-sentry-element="Box" data-sentry-source-file="NoPermission.tsx">
          {headerTitle ?? t("shell.noInvitePermissionTitle")}
        </Box>
        <Typography color="text.secondary" variant="body2" data-sentry-element="Typography" data-sentry-source-file="NoPermission.tsx">
          {headerSubtitle ?? t("shell.noInvitePermissionBody")}
        </Typography>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="NoPermission.tsx">
        <List data-sentry-element="List" data-sentry-source-file="NoPermission.tsx">
          {ownersAndAdmins?.map(user => <ListItem key={user.ZUID} dense disableGutters sx={{
          borderBottom: "1px solid",
          borderColor: "border"
        }}>
              <ListItemAvatar>
                <Avatar alt={`${user.firstName} ${user.lastName}`} src={`https://www.gravatar.com/avatar/${MD5(user.email || "")}?s=40`} />
              </ListItemAvatar>
              <ListItemText primary={`${user.firstName} ${user.lastName}`} primaryTypographyProps={{
            sx: {
              color: "text.primary"
            }
          }} secondary={`${user.role.name} • ${user.email}`} />
            </ListItem>)}
        </List>
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="NoPermission.tsx">
        <Button color="primary" variant="contained" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="NoPermission.tsx">
          {t("common.done")}
        </Button>
      </DialogActions>
    </Dialog>;
};